import type { GeocodedLocation } from './location-select.types';
import type { CompassGeocodeLocation } from './compass-api';

export function parseCompassGeocodeLocationToGeocodedLocation(
	compassLocation: CompassGeocodeLocation,
): GeocodedLocation {
	const {
		postalCode,
		latitude,
		longitude,
		neighborhood,
		city,
		state,
		country,
		googlePlaceId,
		streetName,
		streetNumber,
		fullAddress,
	} = compassLocation;

	return {
		zipcode: postalCode ?? '',
		lat: latitude,
		lng: longitude,
		county: neighborhood ?? '',
		city: city ?? '',
		state: state ?? '',
		country: country ?? '',
		place_id: googlePlaceId,
		address: fullAddress,
		streetName,
		streetNumber,
	};
}
